export default __webpack_public_path__ + "static/media/singlebed1.d42b446c.jpg";